var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.texts.fromLabel)+" "+_vm._s(_vm.currencySymbol)+" "+_vm._s(_vm._f("formatAmount")(_vm.monthlyFee))+"\n  "+_vm._s(_vm.texts.pmLabel))])}
var staticRenderFns = []

export { render, staticRenderFns }